export function getCodesByPage(page: string): string[] {
  const codes: Record<string, string[]> = {
    shadowzone: ['misterio', 'solidao', 'entidade', 'profundeza'],
    neozone: ['cibernetica', 'utopia', 'futuro', 'futuro'],
    openzone: ['realidade', 'infinito', 'potencial', 'galaxia'],
    herozone: ['heroismo', 'coragem', 'justica', 'honra'],
  };

  return codes[page] || [];
}

function getDailyIndex(length: number): number {
  const baseDate = new Date(2026, 3, 30);
  const today = new Date();

  baseDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInMs = today.getTime() - baseDate.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return ((diffInDays % length) + length) % length;
}

export function getCorrectCodeByPage(page: string): string {
  const codes = getCodesByPage(page);
  if (!codes.length) return '';

  return codes[getDailyIndex(codes.length)];
}

function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();
}

export function validateZoneCode(index: number, page: string): boolean {
  if (index !== 0) return true;

  const textarea = document.getElementById('neoZoneCode') as HTMLTextAreaElement | null;
  textarea?.addEventListener('input', () => {
    const cursor = textarea.selectionStart || 0;

    textarea.value = normalizeText(textarea.value);

    textarea.setSelectionRange(cursor, cursor);
  })

  const input = normalizeText(textarea?.value || '');

  const container = document.querySelector('.modal-container') as HTMLElement | null;
  const correctDiv = document.getElementById('correctCodeDiv') as HTMLElement | null;
  const incorrectDiv = document.getElementById('incorrectCodeDiv') as HTMLElement | null;

  correctDiv?.classList.add('hidden');
  incorrectDiv?.classList.add('hidden');

  if (!input) return false;

  container?.classList.remove('hidden');

  const correctCode = normalizeText(getCorrectCodeByPage(page));

  if (input === correctCode) {
    correctDiv?.classList.remove('hidden');
  } else {
    incorrectDiv?.classList.remove('hidden');
  }

  return false;
}